<div #window class="window" [ngStyle]="style" *ngIf="isVisible">
  <div class="header" #headerEl>
    <ng-content select="nrk-header"></ng-content>
    <button class="close-button right" style="width:auto" (click)="hide();onCancel.emit()">X</button>
  </div>
  <div>
    <ng-content select="nrk-fixed-header"></ng-content>
  </div>
  <!-- <div class="resize-handle top" (mousedown)="startResize($event, 'top')"></div>
  <div
    class="resize-handle right"
    (mousedown)="startResize($event, 'right')"
  ></div> -->
  <div class="resize-handle top"></div>
  <div class="resize-handle right"></div>
  <div class="content" #windowContent>
    <div class="scrollable-content">
      <ng-content select="nrk-content"></ng-content>
    </div>
  </div>
  <div class="footer">
    <ng-content select="nrk-footer"></ng-content>
  </div>
</div>
